import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import {
    StyledColumnBox,
    StyledGreenButton,
    StyledMediumTypography,
    StyledModalButtons,
    StyledModalDescription,
    StyledModalTitle,
    StyledRedButton
} from '../../theme/StyledElements';
import { styled } from '@mui/material';

const StyledPublishModal = styled(Box)(() => ({
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '750px',
    backgroundColor: '#FFFFFF'
}));

const StyledPara = styled('p')(() => ({
    marginTop: '15px'
}));

interface BasketPublishModalProps {
    isModelOpen: boolean;
    setModelOpen: Function;
    onButtonClick: Function;
    basketId: string | undefined;
}

export function BasketPublishModal({
    isModelOpen,
    setModelOpen,
    basketId,
    onButtonClick
}: BasketPublishModalProps): JSX.Element {
    const { t } = useTranslation();
    const body = (
        <StyledPublishModal sx={{ border: basketId ? '2px solid #134C03' : '2px solid #DD1313' }}>
            <StyledModalTitle sx={{ backgroundColor: basketId ? '#134C03' : '#DD1313' }}>
                <StyledMediumTypography variant="body1" color="#FFFFFF">
                    {t('publishCart')}
                </StyledMediumTypography>
            </StyledModalTitle>
            {basketId ? (
                <StyledModalDescription variant="h3">
                    {t('cartPublishedToAmoUsers')}
                </StyledModalDescription>
            ) : (
                <StyledColumnBox>
                    <StyledModalDescription variant="h3" color="#000000">
                        <StyledPara> {t('publishFailed1')}</StyledPara>
                        <StyledPara> {t('publishFailed2')}</StyledPara>
                        <StyledPara> {t('publishFailed3')}</StyledPara>
                        <StyledPara> {t('publishFailed4')}</StyledPara>
                    </StyledModalDescription>
                </StyledColumnBox>
            )}
            <StyledModalButtons>
                {basketId ? (
                    <StyledGreenButton onClick={(): void => onButtonClick()}>
                        <StyledMediumTypography variant="caption" color="#FFFFFF">
                            {t('toClose')}
                        </StyledMediumTypography>
                    </StyledGreenButton>
                ) : (
                    <StyledRedButton onClick={(): void => onButtonClick()}>
                        <StyledMediumTypography variant="caption" color="#FFFFFF">
                            {t('toClose')}
                        </StyledMediumTypography>
                    </StyledRedButton>
                )}
            </StyledModalButtons>
        </StyledPublishModal>
    );

    return (
        <Modal
            open={isModelOpen}
            onClose={(): void => {
                setModelOpen(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            {body}
        </Modal>
    );
}
